import React from 'react';
import { Typography, Tag, Space, Divider } from 'antd';
import { CalendarOutlined, TagOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { mockPosts } from '../../api/mockData';

const { Title, Paragraph } = Typography;

const PostDetail = () => {
  const { id } = useParams();
  const post = mockPosts.find(p => p.id === parseInt(id));

  if (!post) {
    return (
      <div style={{ textAlign: 'center', padding: 100 }}>
        <Title level={3}>文章不存在</Title>
      </div>
    );
  }

  return (
    <div className="post-content">
      <Title level={1}>{post.title}</Title>
      
      <Space style={{ marginBottom: 24 }}>
        <CalendarOutlined />
        <span>{moment(post.date).format('YYYY-MM-DD')}</span>
        <TagOutlined />
        <span className="post-tags">
          {post.tags.map(tag => (
            <Tag key={tag} color="blue">{tag}</Tag>
          ))}
        </span>
      </Space>

      <Divider />

      <div style={{ fontSize: 16, lineHeight: 1.8 }}>
        <Paragraph>{post.summary}</Paragraph>
        <Paragraph>
          {post.content || '这里是文章内容。这篇文章内容丰富，包含作者的思考和分享...'}
        </Paragraph>
        <Paragraph>
          文章内容可以很长，这里展示的是文章详情页面。在实际应用中，文章内容会从数据库中获取。
        </Paragraph>
      </div>
    </div>
  );
};

export default PostDetail;